<article #editable [class]=[CLASSES.EDITABLE_BACKGROUND_IMAGE] class="service-article">
  <div class="content-container">
    <h5 #editable>SERVICES</h5>
    <h3 #editable> {{ initialTitle }}</h3>
    <p #editable> {{ initialSubtitle }}</p>
  </div>

</article>
